import type { SmsChat } from "@stockline/shared/types/communications/sms-chat"
import { SMS_CHAT_TABLE } from "../../../lib/offline/resources/communications/sms-chat/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseSmsChatsFilter {
  accountId?: string
  archived?: boolean
  enabled?: boolean
  orderBy?: string
}

export function useSmsChats(filter?: UseSmsChatsFilter): SmsChat[] {
  const { reactive } = useAISync()
  return reactive.useQuery<SmsChat>(SMS_CHAT_TABLE, {
    ...filter,
    orderBy: filter?.orderBy ?? "-lastMessageDate",
  })
}

export function useSmsChat(id: string | null): SmsChat | null {
  const { reactive } = useAISync()
  return reactive.useOne<SmsChat>(SMS_CHAT_TABLE, id ?? "__none__")
}
